module.exports = __webpack_public_path__ + "img/16581245_S.f44e60ab.png";